import { getuserportfolios, getfullportfolio, uploaduserportfolio, matchportfolio, findportfoliotypos, setportfoliovalidation, loadbrainsdata, DownloadPortfolio, DeletePortfolio, saveportfolioconfig, getstrattable, getstrattablefilter } from '@/api/portfolio'
const state = {
  currentportfolio: {
    id: null,
    data: []
  },
  compareportfolio: {
    id: null,
    data: []
  },
  userportfolios: [],
  uploadportfolio: {
    actualstep: 1
  },
  current_filters: null,
  portfolioOrderedFields: []
}

const mutations = {
  SET_USER_PORTFOLIOS: (state, portfolios) => {
    state.userportfolios = portfolios
  },
  SET_CURRENT_PORTFOLIO: (state, portfolio) => {
    state.currentportfolio = portfolio
    state.portfolioOrderedFields = []
  },
  SET_COMPARE_PORTFOLIO: (state, portfolio) => {
    state.compareportfolio = portfolio
  },
  SET_CURRENT_UPLOADPORTFOLIO: (state, portfolio) => {
    state.uploadportfolio = portfolio
  },
  SET_CURRENTFILTERS: (state, filters) => {
    state.current_filters = filters
  },
  SET_orderedfields: (state, portfolioOrderedFields) => {
    state.portfolioOrderedFields = portfolioOrderedFields
  }
}

const actions = {
  getUserPortfolios({ commit }) {
    return new Promise((resolve, reject) => {
      getuserportfolios().then((response) => {
        commit('SET_USER_PORTFOLIOS', response.data)
        resolve()
      }).catch((error) => {
        console.error(error)
        commit('SET_USER_PORTFOLIOS', [])
        reject()
      })
    })
  },
  loadportfolio({ commit }, portfolioid) {
    const actfilter = null
    /*
    if (state.current_filters !== null) {
      // debugger
      actfilter = state.current_filters
    }
    */
    return new Promise((resolve, reject) => {
      getfullportfolio({ id: portfolioid, filters: actfilter }).then((response) => {
        commit('SET_CURRENT_PORTFOLIO', response.data)
        commit('SET_CURRENTFILTERS', response.data.filterColumns)
        resolve()
      }).catch((error) => {
        console.error(error)
        commit('SET_CURRENT_PORTFOLIO', {
          id: null,
          data: []
        })
        reject()
      })
    })
  },
  loadcompareportfolio({ commit }, portfolioid) {
    const actfilter = null
    /*
    if (state.current_filters !== null) {
      // debugger
      actfilter = state.current_filters
    }
    */
    return new Promise((resolve, reject) => {
      getfullportfolio({ id: portfolioid, filters: actfilter }).then((response) => {
        commit('SET_COMPARE_PORTFOLIO', response.data)
        resolve()
      }).catch((error) => {
        console.error(error)
        commit('SET_COMPARE_PORTFOLIO', {
          id: null,
          data: []
        })
        reject()
      })
    })
  },
  loadportfoliofilter({ commit }, filter) {
    return new Promise((resolve, reject) => {
      getfullportfolio({ id: filter.portfolioid, filters: filter.filters }).then(response => {
        // debugger
        commit('SET_CURRENT_PORTFOLIO', response.data)
        commit('SET_CURRENTFILTERS', filter.filters)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  uploaduserportfolio({ commit }, data) {
    return new Promise((resolve, reject) => {
      uploaduserportfolio(data).then((response) => {
        const actport = state.uploadportfolio.actualstep = 2
        commit('SET_CURRENT_UPLOADPORTFOLIO', actport)
        resolve(response.data)
      }).catch((error) => {
        console.error(error)
        // debugger
        reject()
      })
    })
  },
  startnewportfolio({ commit }) {
    return new Promise((resolve, reject) => {
      commit('SET_CURRENT_UPLOADPORTFOLIO', {
        actualstep: 1
      })
      resolve()
    })
  },
  changeportfoliostep({ commit }, portfolio) {
    return new Promise((resolve, reject) => {
      commit('SET_CURRENT_UPLOADPORTFOLIO', portfolio)
      resolve()
    })
  },
  findportfoliotypos({ commit }, data) {
    return new Promise((resolve, reject) => {
      findportfoliotypos(data).then((response) => {
        resolve(response.data)
      }).catch((error) => {
        console.error(error)
        // debugger
        reject()
      })
    })
  },
  DownloadPortfolio({ commit }, data) {
    return new Promise((resolve, reject) => {
      DownloadPortfolio(data).then((response) => {
        resolve(response.data)
      }).catch((error) => {
        console.error(error)
        // debugger
        reject()
      })
    })
  },
  DeletePortfolio({ commit }, data) {
    return new Promise((resolve, reject) => {
      DeletePortfolio(data).then((response) => {
        resolve(response.data)
      }).catch((error) => {
        console.error(error)
        // debugger
        reject()
      })
    })
  },
  setportfoliovalidation({ commit }, data) {
    return new Promise((resolve, reject) => {
      setportfoliovalidation(data).then((response) => {
        resolve(response.data)
      }).catch((error) => {
        console.error(error)
        // debugger
        reject()
      })
    })
  },
  loadbrainsdata({ commit }, data) {
    return new Promise((resolve, reject) => {
      loadbrainsdata(data).then((response) => {
        resolve()
      }).catch((error) => {
        console.error(error)
        // debugger
        reject()
      })
    })
  },
  getportfoliovalidation({ commit }, data) {
    return new Promise((resolve, reject) => {
      matchportfolio(data).then((response) => {
        // debugger
        resolve(response.data)
      }).catch((error) => {
        console.error(error)
        // debugger
        reject()
      })
    })
  },
  getstrattable({ commit }, data) {
    return new Promise((resolve, reject) => {
      getstrattable(data).then((response) => {
        resolve(response.data)
      }).catch((error) => {
        console.error(error)
        // debugger
        reject()
      })
    })
  },
  getstrattablefilter({ commit }, data) {
    return new Promise((resolve, reject) => {
      getstrattablefilter(data).then((response) => {
        // debugger
        resolve(response.data)
      }).catch((error) => {
        console.error(error)
        // debugger
        reject()
      })
    })
  },
  saveportfolioconfig({ commit }, data) {
    return new Promise((resolve, reject) => {
      saveportfolioconfig(data).then((response) => {
        // debugger
        resolve(response.data)
      }).catch((error) => {
        console.error(error)
        // debugger
        reject()
      })
    })
  },
  setOrderedFields({ state, commit }, { value }) {
    commit('SET_orderedfields', value)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
